export default {
  /**
   * 店舗条件の標準フォーマット
   */
  get() {
    return {
      /**
       * キー
       *
       * 店舗条件は複雑な内部構造を持つ（店舗グループを内部でFetchしたり、店舗グループ変更
       * をトリガーに店舗一覧をFetchしたり）ので、その辺まで考慮しようとすると復元処理が
       * 非常に煩雑になる。
       * 強制的にコンポーネントを再構築させるために復元のときだけkey属性を操作します。
       */
      key: new Date().getTime().toString(),
      /**
       * 店舗グループ
       */
      storeGroup: undefined,
      /**
       * 店舗コード一覧
       */
      stores: [],
      /**
       * 入力エラー
       */
      errors: [],
    }
  },
  /**
   * 分析APIで使用する期間のフォーマットに変換する
   */
  mapToApiPayload(store) {
    return {
      storeGroup: store.storeGroup,
      stores: store.stores,
    }
  },
  /**
   * applyToに対してstoreを適用する
   */
  applyPayload(applyTo, store) {
    applyTo.key = new Date().getTime().toString()

    // 対象/比較パターン
    if (store.base) {
      // "base"を採用。"compare"はこの時点で捨てられてしまうので注意
      applyTo.storeGroup = store.base.storeGroup
      applyTo.stores = store.base.stores
      return
    }

    applyTo.storeGroup = store.storeGroup
    applyTo.stores = store.stores
  },
  summaryText(store) {
    return store.stores.length + '店舗'
  },
}
